import { SvgIcon } from "@mui/material";
import React from "react";

function Share(props) {
  return (
    <SvgIcon viewBox="0 0 15 13" {...props}>
      <path
        d="M7.5 1V8.33333M7.5 1L4.9 3.44444M7.5 1L10.1 3.44444M1 9.55556L1.40365 11.0742C1.47395 11.3386 1.63624 11.5733 1.86471 11.7411C2.09319 11.9088 2.37476 12 2.66465 12H12.3353C12.6252 12 12.9068 11.9088 13.1353 11.7411C13.3638 11.5733 13.5261 11.3386 13.5963 11.0742L14 9.55556"
        stroke="#5F5C5C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default Share;
